import { Skeleton, Stack } from '@mantine/core';

interface MarkdownSkeletonProps {
  height?: number;
  rows?: number;
  columns?: number;
}

/**
 * Skeleton for markdown components during loading/streaming states.
 * Shows text-like lines with varying widths.
 */
export function MarkdownSkeleton({ height: _height, rows = 4, columns: _columns }: MarkdownSkeletonProps) {
  // Generate varying widths for paragraph-like appearance
  const lineWidths = Array.from({ length: rows }, (_, i) => {
    if (i === 0) {
      return 40; // Title line
    }
    if (i === rows - 1) {
      return 60 + ((i * 13) % 25); // Last line shorter
    }
    return 80 + ((i * 11) % 20);
  });

  return (
    <Stack gap="sm">
      {lineWidths.map((width, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list that never reorders
        <Skeleton animate height={i === 0 ? 24 : 16} key={i} radius="sm" width={`${width}%`} />
      ))}
    </Stack>
  );
}
